import axios from "../axios/axios";
import {
  LoyaltyTransactionFilters,
  UserLoyaltyTransactionResponse,
} from "../types/loyaltyTypes";

export const fetchUserLoyaltyTransactions = async (
  filters: LoyaltyTransactionFilters
): Promise<UserLoyaltyTransactionResponse[]> => {
  try {
    // Get current user ID from localStorage
    const userId = localStorage.getItem("id");

    if (!userId) {
      throw new Error("User ID not found in localStorage");
    }

    // Format dates to ISO strings
    const createdFrom = filters.createdFrom.toISOString();
    const createdTo = filters.createdTo.toISOString();

    // Build filter string for the specific user
    const userFilter = `user.id:${userId}`;

    const params = {
      createdFrom,
      createdTo,
      filter: userFilter,
      page: filters.page,
      numOfReturns: filters.numOfReturns,
    };

    console.log("Fetching loyalty transactions with params:", params);

    const response = await axios.get<UserLoyaltyTransactionResponse[]>(
      "/user_loyalty_transaction",
      { params }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching loyalty transactions:", error);
    throw error;
  }
};

// Helper function to calculate total points from transactions
export const calculateTotalPoints = (
  transactions: UserLoyaltyTransactionResponse[]
): number => {
  return transactions.reduce((total, transaction) => {
    return total + Number(transaction.loyaltyPoints);
  }, 0);
};

// Helper function to group transactions by type
export const groupTransactionsByType = (
  transactions: UserLoyaltyTransactionResponse[]
): Record<string, UserLoyaltyTransactionResponse[]> => {
  return transactions.reduce((groups, transaction) => {
    const type = transaction.type;
    if (!groups[type]) {
      groups[type] = [];
    }
    groups[type].push(transaction);
    return groups;
  }, {} as Record<string, UserLoyaltyTransactionResponse[]>);
};
